import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import { post_article, clear_post_success_error } from "../../redux/actions";
import { Form, Button, Container } from "react-bootstrap";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import NewArticleModal from "../../components/newArticleModal";

export default function NewArticle() {
  const dispatch = useDispatch();
  const history = useHistory();
  const globalState = useSelector((state) => state);

  const [articleState, setArticleState] = useState({
    title: "",
    titleImage: "",
    description: "",
    article: "",
    tags: [],
    tag: "",
  });

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  function onPublishClick(e) {
    e.preventDefault();
    const articlePostObject = {
      article: {
        title: articleState.title,
        titleImage: articleState.titleImage,
        description: articleState.description,
        body: articleState.article,
        tagList: articleState.tags,
      },
    };
    dispatch(
      post_article(
        "post",
        `${process.env.REACT_APP_URL}/api/articles`,
        articlePostObject
      )
    );
  }

  useEffect(() => {
    setArticleState({
      ...articleState,
      article: draftToHtml(convertToRaw(editorState.getCurrentContent())),
    });
  }, [editorState]);

  useEffect(() => {
    setTags();
  }, [articleState]);

  function setTags() {
    if (articleState.tag.includes(",")) {
      setArticleState({
        ...articleState,
        tags: [
          ...articleState.tags,
          articleState.tag.substring(0, articleState.tag.length - 1),
        ],
        tag: "",
      });
    }
  }

  function onChangeHandler(e) {
    const { name, value } = e.target;
    setArticleState({
      ...articleState,
      [name]: value,
    });
  }

  function onEnterPress(e) {
    const {
      charCode,
      target: { value },
    } = e;
    if (charCode === 13) {
      setArticleState({
        ...articleState,
        tags: [...articleState.tags, value],
        tag: "",
      });
    }
  }

  function onRichTextEditorChange(e) {
    setEditorState(e);
  }

  function handleDelete(i) {
    setArticleState({
      ...articleState,
      tags: articleState.tags.filter((_, index) => index !== i),
    });
  }

  function modalFuction(type) {
    if (type === "homepage") {
      dispatch(clear_post_success_error());
      history.push("/");
    } else if (type === "hide") {
      setEditorState(EditorState.createEmpty());
      setArticleState({
        ...articleState,
        title: "",
        titleImage: "",
        description: "",
        article: "",
        tags: [],
        tag: "",
      });
      dispatch(clear_post_success_error());
    }
  }

  return (
    <Container>
      <NewArticleModal
        show={globalState.createPost}
        onGotoHomepage={() => modalFuction("homepage")}
        onHide={() => modalFuction("hide")}
      />
      <Form>
        <Form.Group className="mb-3" controlId="formBasicTitle">
          <Form.Label>Title</Form.Label>
          <Form.Control
            name="title"
            value={articleState.title}
            onChange={onChangeHandler}
            type="text"
            placeholder="Enter title"
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicTitleImage">
          <Form.Label>Title Image Url</Form.Label>
          <Form.Control
            name="titleImage"
            value={articleState.titleImage}
            onChange={onChangeHandler}
            type="text"
            placeholder="Enter Image Url"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicDescription">
          <Form.Label>Description</Form.Label>
          <Form.Control
            name="description"
            value={articleState.description}
            onChange={onChangeHandler}
            type="text"
            placeholder="Enter Description"
          />
          <small className="text-muted">Max Length: 200</small>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicDescription">
          <Form.Label>Article</Form.Label>
          {/* <Form.Control type="text" placeholder="Enter Description" /> */}
          <div>
            <Editor
              editorState={editorState}
              wrapperClassName="border wrapper-class"
              editorClassName="editor-class"
              toolbarClassName="toolbar-class"
              onEditorStateChange={onRichTextEditorChange}
              // onChange={onRichTextEditorChange}
              editorStyle={{ height: "400px" }}
            />
          </div>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicDescription">
          <Form.Label>Tags</Form.Label>
          {articleState.tags.length > 0 && (
            <div className="mb-3 show-tags">
              <div className="rounded d-flex">
                {articleState.tags.map((item, id) => (
                  <div
                    key={id}
                    className="rounded-pill px-0 text-center text-white bg-success px-2 article-page-tags"
                  >
                    <div className="d-flex">
                      {item}
                      <div
                        className="text-white"
                        onClick={() => handleDelete(id)}
                      >
                        <i className="bi bi-x" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          <input
            type="text"
            className="form-control"
            id="exampleInputArticleTags"
            name="tag"
            onChange={onChangeHandler}
            value={articleState.tag}
            onKeyPress={onEnterPress}
          />
        </Form.Group>
        <Button variant="primary" onClick={onPublishClick}>
          Submit
        </Button>
      </Form>
    </Container>
  );
}
